import { render, staticRenderFns } from "./TariffCalculatorHCMInfoModal.vue?vue&type=template&id=f5480606&"
import script from "./TariffCalculatorHCMInfoModal.vue?vue&type=script&lang=ts&"
export * from "./TariffCalculatorHCMInfoModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports